import { render, staticRenderFns } from "./ScoreGauge.vue?vue&type=template&id=4af22dd9&scoped=true"
import script from "./ScoreGauge.vue?vue&type=script&lang=js"
export * from "./ScoreGauge.vue?vue&type=script&lang=js"
import style0 from "./ScoreGauge.vue?vue&type=style&index=0&id=4af22dd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af22dd9",
  null
  
)

export default component.exports